import { StreamChat } from "stream-chat";
let chatClient;
export const getChatClient = (streamkey) => {
  if (!chatClient) {
    
    chatClient = StreamChat.getInstance(streamkey, {
      timeout: 6000,
    });
  }
  return chatClient;
};
